const RenderExamComponent = ({ label, count }) => (
  <>
    <div className="item-label">{label}</div>
    <div className="quantity">{count}</div>
  </>
)

export default RenderExamComponent
